import {put,} from '../utils'

export default host => (file, users) => {
  const object = {}
  object.users = users.length > 0 ? users.map(user => user.value) : {}

  return put(`${host}/user/files/${file.id}/perms`, JSON.stringify(object))
    .then(response => response.json())
}